var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M27.6316 2.52637H2.36842C1.02632 2.52637 0 3.55268 0 4.89479V19.1053C0 20.4474 1.10526 21.4737 2.36842 21.4737H27.6316C28.9737 21.4737 30 20.4474 30 19.1053V4.89479C30 3.55268 28.8947 2.52637 27.6316 2.52637Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6315 3.31592C28.5 3.31592 29.2105 4.02644 29.2105 4.89487V19.1054C29.2105 19.9738 28.5 20.6843 27.6315 20.6843H2.36838C1.49996 20.6843 0.789429 19.9738 0.789429 19.1054V4.89487C0.789429 4.02644 1.49996 3.31592 2.36838 3.31592H27.6315Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8421 17.5263C14.8942 17.5263 17.3684 15.052 17.3684 11.9999C17.3684 8.94785 14.8942 6.47363 11.8421 6.47363C8.79001 6.47363 6.3158 8.94785 6.3158 11.9999C6.3158 15.052 8.79001 17.5263 11.8421 17.5263Z",
    fill: "#EB001B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1579 17.5263C21.21 17.5263 23.6842 15.052 23.6842 11.9999C23.6842 8.94785 21.21 6.47363 18.1579 6.47363C15.1058 6.47363 12.6316 8.94785 12.6316 11.9999C12.6316 15.052 15.1058 17.5263 18.1579 17.5263Z",
    fill: "#F79E1B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3684 12C17.3684 10.1053 16.4211 8.44737 15 7.5C13.579 8.52632 12.6316 10.1842 12.6316 12C12.6316 13.8158 13.579 15.5526 15 16.5C16.4211 15.5526 17.3684 13.8947 17.3684 12Z",
    fill: "#FF5F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.b27f59a18654c7d5a52d136afd7ca329.svg";
export { ForwardRef as ReactComponent };